module.exports = __webpack_public_path__ + "static/media/fixed_voice_arrow_left.4a941338.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_arrow_left.svg
// module id = 3151
// module chunks = 0